import { Locale, type Localized } from "../schema/Locale.js";
import type { Tenant } from "../schema/Tenant.js";
import { isEnum } from "../utils/enum/isEnum.js";
import tenants from "./tenants.json" with { type: "json" };

const isLocale = isEnum(Locale);
const prefixPattern = /^(?:\/[a-z0-9-]+)*$/u;

function isTenant(obj: unknown): obj is Tenant {
	return (
		obj !== null &&
		typeof obj === "object" &&
		"locale" in obj &&
		isLocale(obj.locale) &&
		"prefix" in obj &&
		typeof obj.prefix === "string" &&
		prefixPattern.test(obj.prefix)
	);
}

const map: Partial<Localized<Tenant>> = {};
try {
	if (!Array.isArray(tenants)) {
		throw new Error("Not an array");
	}
	if (tenants.length !== Object.values(Locale).length) {
		throw new Error("Record count does not match");
	}
	for (const tenant of tenants) {
		if (!isTenant(tenant)) {
			throw new Error("Invalid record");
		}
		if (map[tenant.locale]) {
			throw new Error("Duplicate tenant locale found");
		}
		if (Object.values(map).some(({ prefix }) => prefix === tenant.prefix)) {
			throw new Error("Duplicate prefix found");
		}
		map[tenant.locale] = tenant;
	}
} catch (err) {
	throw new Error(`Tenants config invalid: ${String(err)}`);
}
const frozen = Object.freeze(map as Localized<Tenant>);
const found = Object.values(frozen).find(({ prefix }) => prefix === "");
if (found === undefined) {
	throw new Error("Tenants config invalid: No tenant is served from the root");
}
const root: Tenant = found;
export { frozen as tenants, root as rootTenant };
